<template>
  <div
    class="ma-2 pa-2"
    :style="dataField['style'] + `;border-radius: 5px;border:1px solid #ddd`"
    v-if="dataField.params.fields"
  >
    <h4 class="text-right mb-1">
      {{ dataField.title ? dataField.title : "" }}
    </h4>
    <v-row v-for="i of fieldCount" :key="i">
      <v-col cols="12" v-for="(item, index) in subForm" :key="index">
        <Form
          :field="item"
          :field-name="getName(item, i, dataField.name)"
        ></Form>
      </v-col>
      <v-col v-if="i > 0 && i < fieldCount">
        <v-divider inset> </v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-left">
        <v-btn color="success" @click="fieldCount++" dark small>
          افزودن <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="fieldCount > 1"
          color="error"
          @click="fieldCount--"
          dark
          small
        >
          حذف <v-icon dark>mdi-minus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from "../components/FormNested.vue";

export default {
  name: "SubFormBox",
  components: { Form },
  props: ["dataField"],
  watch: {
    fieldCount: {
      handler: function (newValue) {
        this.$store.commit("updateDataPostByIndex", {
          index: this.dataField.name,
          val: newValue,
        });
      },
    },
  },
  mounted() {
    this.subForm = this.dataField.params.fields;

    this.fieldCount++;
    this.render = true;
  },
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  data: () => ({
    fieldCount: 0,
    subForm: {},
    render: false,
    required: [(v) => !!v || "this is required"],
  }),
  methods: {
    getName(item, index, fieldName) {
      if (!item.name) return item;
      return { name: fieldName + "[" + index + "]" + "[" + item.name + "]" };
    },
  },
};
</script>
